import { useCallback, useEffect, useState } from 'react';
import { Modal, SwipeableDrawer, useMediaQuery } from '@mui/material';
import { useLanguageQuery } from 'next-export-i18n';
import { cloneDeep } from 'lodash';
import { useTutorial } from '../../contexts';
import { ActionEnum, ITutorial } from '../../repository/types';
import Slider from '../Slider';

const Main = () => {
    const [query] = useLanguageQuery();
    const lang = query ? query.lang : 'en';

    const rtl = lang === 'ar';

    const isMobile = useMediaQuery('(max-width: 429px)');

    const { tutorial: preTutorial, hasError, setAction, close } = useTutorial();

    const [tutorial, setTutorial] = useState<ITutorial | undefined>(undefined);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(false);

        if (preTutorial) {
            setTimeout(() => {
                setOpen(true);
                setTutorial(preTutorial);
            }, 300);
        }

        const lastTutorial = cloneDeep(preTutorial);
        return () => {
            if (lastTutorial) {
                setAction(lastTutorial.id, ActionEnum.View);
            }
        };
    }, [preTutorial]);

    const doneHandler = useCallback(
        (error?: boolean) => {
            if (!tutorial) {
                return;
            }

            setAction(tutorial.id, error ? ActionEnum.Skip : ActionEnum.Done);
        },
        [tutorial],
    );

    if (!tutorial || hasError) {
        return null;
    }

    const closeHandler = () => {
        if (tutorial) {
            setAction(tutorial.id, ActionEnum.Skip);
        }
        setOpen(false);
    };

    const content = () => {
        return (
            <Slider
                key={tutorial.id}
                lang={lang}
                theme="normal"
                rtl={rtl}
                tutorial={tutorial}
                onDone={doneHandler}
                setOpen={setOpen}
                close={close}
            />
        );
    };

    if (isMobile) {
        return (
            <SwipeableDrawer anchor="bottom" open={open} onOpen={() => setOpen(true)} onClose={closeHandler}>
                {content()}
            </SwipeableDrawer>
        );
    }

    return (
        <Modal
            open={open}
            onClose={closeHandler}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {content()}
        </Modal>
    );
};

export default Main;
